import { render, staticRenderFns } from "./ui-animation-dropdown.vue?vue&type=template&id=19da2974&"
import script from "./ui-animation-dropdown.vue?vue&type=script&lang=ts&"
export * from "./ui-animation-dropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports